// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '../outgoing-payment/types';

export function ecuadorianOutgoingPaymentMapper(userInputValues: UserInputValues): $Shape<OutgoingPayment> {
  return {
    country: 'ec',
    document: userInputValues['ecuadorianDocument'],
    document_type: userInputValues['ecuadorianDocumentType'],
    zipcode: userInputValues['ecuadorianZipcode'],
    state: userInputValues['ecuadorianState'],
    city: userInputValues['ecuadorianCity'],
    address: userInputValues['ecuadorianAddress'],
    street_number: userInputValues['ecuadorianStreetNumber'],
    street_complement: userInputValues['ecuadorianStreetComplement'],
    phone_number: userInputValues['ecuadorianPhoneNumber'],
  };
}
